import {Pipe, PipeTransform} from '@angular/core';
import {TicketAttachment} from '../../model/Ticket';

@Pipe({
  name: 'cidTransform',
  standalone: true,
})
export class CidTransformPipe implements PipeTransform {
  transform(html: string, attachments: TicketAttachment[]): string {
    if (html == null) {
      return '';
    }
    html = this.transformCid(html, attachments, 'inline');
    html = this.transformCid(html, attachments, 'pasted');
    return html;
  }

  transformCid(html: string, attachments: TicketAttachment[], type: string): string {
    let start = html.indexOf('cid:' + type);
    while (start !== -1) {
      const end = html.substr(start).indexOf('"');
      const inlineStr = html.substr(start, end);

      // Find the right attachment
      const found = attachments.find(a => a.id != null && a.id.indexOf(inlineStr.substr(4)) !== -1);
      attachments.splice(attachments.indexOf(found), 1);

      html = html.replace(inlineStr, `data:${found.contentType.split(';')[0]};base64,` + found.content);
      start = html.indexOf('cid:' + type);
    }
    return html;
  }
}
